import script from "./middle-video.vue?vue&type=script&setup=true&lang=js"
export * from "./middle-video.vue?vue&type=script&setup=true&lang=js"

import "./middle-video.vue?vue&type=style&index=0&id=e0ddcf0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ddcf0e"]])

export default __exports__